import React, { useEffect, useRef } from "react";
import { Alert, Button, Form, Input, Modal, Spin } from "antd";
import { PhoneOutlined, LockOutlined } from "@ant-design/icons";
import useCustomerSession from "./useCustomerSession";
import CustomerPortal from "./customer-portal/CustomerPortal";
import { asset } from "./memberData";
import "../../styles/customerLookup.css";
import "../../styles/memberRefinements.css";
import "./customer-playlist/customerPlaylist.css";

export default function CustomerLookupModal({ open, onClose }) {
  const session = useCustomerSession(open);
  const pinInputRef = useRef(null);
  useEffect(() => {
    if (open && session.step === "pin" && !session.loading) {
      pinInputRef.current?.focus({ preventScroll: true });
    }
  }, [open, session.step, session.loading]);
  const close = () => { session.reset(); onClose(); };
  const isProfile = session.step === "profile";
  return (
    <Modal open={open} centered footer={null} onCancel={close} maskClosable={false}
      width={isProfile ? 1205 : 460} destroyOnClose
      title={isProfile ? <span className="member-sr-only">Khu vực thành viên Muzic Box</span> : "Tra cứu khách hàng"}
      closeIcon={<img src={asset("overview-imgIconoirCancel.svg")} alt="Đóng" />}
      className={`customer-lookup-modal ${isProfile ? "member-modal" : "member-auth-modal"}`}>
      {isProfile ? <CustomerPortal profile={session.profile} onSaveProfile={session.saveProfile} onSearchSongs={session.searchSongs} saving={session.loading} profileError={session.error} profileNotice={session.notice} onSwitchAccount={() => session.reset()} onClose={close} /> : (
        <div className="member-auth">
          <p className="member-muted">Thông tin thành viên, bài hát yêu thích và những ưu đãi dành cho bạn.</p>
          {session.notice && <Alert type="info" showIcon message={session.notice} />}
          {session.error && <Alert role="alert" type="error" showIcon message={session.error} />}
          {session.step === "phone" && <Form key="phone" layout="vertical" onFinish={({ mobile }) => session.requestPin(mobile)}>
            <Form.Item name="mobile" label="Số điện thoại" rules={[{ required: true, message: "Vui lòng nhập số điện thoại" }, { pattern: /^(?:0\d{9}|(?:\+?84)\d{9})$/, message: "Số điện thoại không hợp lệ" }]}>
              <Input size="large" inputMode="tel" autoComplete="tel" prefix={<PhoneOutlined />} placeholder="Nhập số điện thoại" maxLength={13} disabled={session.loading} />
            </Form.Item>
            <Button block type="primary" size="large" htmlType="submit" loading={session.loading}>Nhận mã PIN</Button>
          </Form>}
          {session.step === "pin" && <Form key="pin" layout="vertical" onFinish={({ pin }) => session.verifyPin(pin)}>
            <Form.Item name="pin" label="PIN 6 số" rules={[{ required: true, message: "Vui lòng nhập PIN" }, { pattern: /^\d{6}$/, message: "PIN gồm 6 chữ số" }]}>
              <Input.Password ref={pinInputRef} size="large" inputMode="numeric" autoComplete="off" prefix={<LockOutlined />} placeholder="Nhập PIN" maxLength={6} disabled={session.loading} />
            </Form.Item>
            <Button block type="primary" size="large" htmlType="submit" loading={session.loading}>Xác nhận</Button>
            <Button type="text" onClick={() => session.reset()}>Đổi số điện thoại</Button>
          </Form>}
          {session.step === "loadingProfile" && <div className="member-auth-retry">
            {session.loading ? <Spin tip="Đang tải thông tin"><div className="member-loading-space" /></Spin> : <Button type="primary" onClick={session.retryProfile}>Thử tải lại thông tin</Button>}
            <Button type="text" onClick={() => session.reset()}>Tra cứu số khác</Button>
          </div>}
        </div>
      )}
    </Modal>
  );
}
